import { render } from "./Distributors.vue?vue&type=template&id=912a0a98&ts=true"
import script from "./Distributors.vue?vue&type=script&lang=ts"
export * from "./Distributors.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__